import React, { useState, useEffect, useContext, useRef } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { Wrench, CirclePercent, ChevronsRight, Percent, ChevronLeft, House, AlignJustify, FlaskConical } from 'lucide-react';

import ProjectsSummaryData from '/src/Components/ProjectsSummaryData/ProjectsSummaryData';
import './style.css';
import HouseView from './HouseView/HouseView';
import ListView from './ListView/ListView';
import WhatWeWouldDo from './WhatWeWouldDo/WhatWeWouldDo';
import { DndContext, useDraggable, useDroppable } from '@dnd-kit/core';
// Import the Contexts
import { AreaDataContext } from '../../PropertyExplorer';
import { ProjectsPayoffContext } from '../YourOptions';
import ScheduleTimeWithQuoll from '/src/Components/ScheduleTimeWithQuoll/ScheduleTimeWithQuoll';
import SendProjectToOthers from '/src/Components/SendProjectToOthers/SendProjectToOthers';
import HelpMeChoose from '/src/Components/HelpMeChoose/HelpMeChoose';
import { WindowSizeContext } from '/src/App';
import WhatIfMachinePlanSummary from '/src/Components/WhatIfMachinePlanSummary/WhatIfMachinePlanSummary';



const ViewProjects = ({ propertyData, setShowHowToNavigate, handleToggleHowToNavigateOn }) => {
    const { deviceType } = useContext(WindowSizeContext);
    // Context variables
    const { refinedProjectsList,
        handleProjectClick,
        handleUserAddingSimulatorProjectId,
        handleUserRemovingSimulatorProjectId,
        selectedProjectsList,
        notSelectedProjectsList,
        userSelectedSimulatorProjectIds,
        handleClearSimulator,
        // handleLabToggle,
        selectedSection,
        setSelectedSection,
        setSelectedProjectsList,
        whatWeWouldDoSlug,
        helpMeChooseSlug,
        browseSlug,
        inComboLabSlug,
        comboLabSlug
        // selectedProject,
        // handleCloseProjectClick,
        // setSelectedSection,
    } = useContext(ProjectsPayoffContext);

    // State variables
    const [propertyAreasWithProjects, setPropertyAreasWithProjects] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);
    const [projectsView, setProjectsView] = useState(whatWeWouldDoSlug);
    const [projectsViewNavHoverId, setProjectsViewNavHoverId] = useState(null);
    const [draggingActive, setDraggingActive] = useState(false);
    const [draggingMoving, setDraggingMoving] = useState(false);
    const [draggingOver, setDraggingOver] = useState(false);
    const [draggingEnded, setDraggingEnded] = useState(false);
    const [showLab, setShowLab] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupType, setPopupType] = useState(null);


    const {
        handleUserAddingTapProjectId,
        handleUrlSubsectionChange,
        handleRevertToPreviousSubsectionUrl,
        handleLoggingGaEventFromProperty
        // tapProjects,
        // handleUserRemovingTapProjectId,
        // goToTakingAction,
        // handleRevertToPreviousSubsectionUrl
    } = useContext(AreaDataContext);


    // Image variables
    // TOGGLE MENU
    const house_view_icon_filename_dark = "get-quoll-projects-house-icon-dark.svg"
    const house_view_icon_url_dark = CreateCloudfrontUrl(house_view_icon_filename_dark);
    const house_view_icon_filename_light = "get-quoll-projects-house-icon-light.svg"
    const house_view_icon_url_light = CreateCloudfrontUrl(house_view_icon_filename_light);
    const list_view_icon_filename_dark = "get-quoll-projects-list-icon-dark.svg"
    const list_view_icon_url_dark = CreateCloudfrontUrl(list_view_icon_filename_dark);
    const list_view_icon_filename_light = "get-quoll-projects-list-icon-light.svg"
    const list_view_icon_url_light = CreateCloudfrontUrl(list_view_icon_filename_light);
    const help_me_choose_icon_filename_dark = "help-me-choose-project-grey.png"
    const help_me_choose_icon_url_dark = CreateCloudfrontUrl(help_me_choose_icon_filename_dark);
    const help_me_choose_icon_filename_light = "help-me-choose-project-tan.png"
    const help_me_choose_icon_url_light = CreateCloudfrontUrl(help_me_choose_icon_filename_light);


    // HELP MENU
    const schedule_time_with_quoll_icon_filename = "fact-finding-stage-talk-with-quoll-icon-grey.png"
    const schedule_time_with_quoll_icon_url = CreateCloudfrontUrl(schedule_time_with_quoll_icon_filename);
    const get_advice_from_others_icon_filename = "fact-finding-stage-send-to-others-icon-grey.png"
    const get_advice_from_others_icon_url = CreateCloudfrontUrl(get_advice_from_others_icon_filename);
    const how_to_navigate_icon_filename = "question-mark-icon-grey.png"
    const how_to_navigate_icon_url = CreateCloudfrontUrl(how_to_navigate_icon_filename);

    // Get property areas threatened, projects list, number of projects, total discounts, and climate risks
    const property_areas_threatened = propertyData?.data?.property_areas_threatened?.house_categories_with_risks || [];
    const climate_risks = propertyData?.data?.climate_risks || [];

    // 1. Calculate total risk across all areas
    const totalRisk = property_areas_threatened.reduce((sum, area) => {
        return sum + (area.rebuild_risk_weighted_likelihood_est || 0);
    }, 0);

    // UseEffect to monitor for property_areas_threatened and refinedProjectsList changes, and update the propertyAreasWithProjects state
    useEffect(() => {
        if (property_areas_threatened.length && refinedProjectsList.length) {

            const enrichedAreas = property_areas_threatened.map(area => {

                const risk_pct_doughtnut = totalRisk ?
                    ((area.rebuild_risk_weighted_likelihood_est || 0) / totalRisk) * 100 :
                    0

                // Find all matching projects for this area
                const matchingProjects = refinedProjectsList.filter(project =>
                    project.project_home_category_id === area.id
                );

                // Calculate total discounts from all matching projects
                const totalDiscounts = matchingProjects.reduce((sum, project) =>
                    sum + (project.project_discounts_company_logos?.length || 0), 0
                );

                // Sort the matching projects by project_payoff_by_scenario[0].by_total.total
                matchingProjects.sort((a, b) => b.project_payoff_by_scenario[0].by_total.total - a.project_payoff_by_scenario[0].by_total.total);

                return {
                    ...area,
                    num_projects: matchingProjects.length,
                    num_discounts: totalDiscounts,
                    projects_list: matchingProjects,
                    risk_level_adjusted: risk_pct_doughtnut > 10 ? 'high' : risk_pct_doughtnut > 5 ? 'medium' : 'low'
                };
            });

            setPropertyAreasWithProjects(enrichedAreas);
        }
    }, [property_areas_threatened, refinedProjectsList]);

    // useEffect that monitors userSelectedSimulatorProjectIds and if that changes to an empty set while projectView is inComboLabSlug, set projectsView to 'house'
    useEffect(() => {
        if (userSelectedSimulatorProjectIds.size === 0 && selectedSection === inComboLabSlug) {
            setSelectedSection(whatWeWouldDoSlug);
        }
    }, [userSelectedSimulatorProjectIds, selectedSection]);

    // Create a handler that updates the selected area when a new area is clicked (or to null if the same area is clicked again)
    const handleAreaClick = (areaId) => {

        // If the areaId is null, set the selected area to null
        if (areaId === null) {
            setSelectedArea(null);
            return;
        }

        // Get the area from the propertyAreasWithProjects array
        const area = propertyAreasWithProjects.find(area => area.id === areaId);

        // If selectedArea.id is not the same as areaId, set the selected area to the area
        if (selectedArea?.id !== areaId) {
            setSelectedArea(area);
        }

        // If selectedArea.id is the same as areaId, set the selected area to null
        else {
            setSelectedArea(null);
        }
    };

    const handleDragStart = (event) => {
        setDraggingActive(true);
    }

    const handleDragMove = (event) => {
        setDraggingMoving(true);
    }

    const handleDragOver = (event) => {
        setDraggingOver(true);
    }


    // Add drop handling
    const handleDragEnd = (event) => {
        setDraggingActive(false);
        setDraggingMoving(false);
        setDraggingOver(false);
        setDraggingEnded(true);
        const { active, over } = event;
        if (!over) return;

        switch (over.id) {
            case 'simulator':
                // Use the existing handler from context
                // console.log('Dropped in simulator:', active.id);
                handleUserAddingSimulatorProjectId(active.id);
                break;
            case 'action-hub':
                // Add to the tap projects
                handleUserAddingTapProjectId(active.id);
                break;
        }
    };

    // Handle clicking on scheduling time or getting advice from others
    const handleScheduleTimeOrGetAdviceClick = (type) => {
        if (type === 'how-to-navigate') {
            handleToggleHowToNavigateOn();
        }
        else {
            setShowPopup(true);
            setPopupType(type);
            handleUrlSubsectionChange(type);
        }
    }

    // Handler for closing the popup
    const handleClosePopup = () => {
        setShowPopup(false);
        setPopupType(null);
        handleRevertToPreviousSubsectionUrl();
    }

    const menuItems = [
        {
            id: whatWeWouldDoSlug,
            label: "What We'd Do",
            icon: "recommendations-order-of-operations-icon.svg",
            icon_dark: house_view_icon_url_dark,
            icon_light: house_view_icon_url_light,
        },
        {
            id: helpMeChooseSlug,
            label: 'Help Me Choose',
            icon: "recommendations-help-me-choose-icon.svg",
            icon_dark: help_me_choose_icon_url_dark,
            icon_light: help_me_choose_icon_url_light,
        },
        {
            id: browseSlug,
            label: 'Browse Projects',
            icon: "recommendations-browse-projects-icon.svg",
            icon_dark: list_view_icon_url_dark,
            icon_light: list_view_icon_url_light,
        },
    ]

    const getAdviceFromOthersSlug = 'get-advice-from-others';
    const scheduleTimeWithQuollSlug = 'schedule-time-with-quoll';

    const needAdditionalHelpMenuItems = [
        {
            id: getAdviceFromOthersSlug,
            label: 'Get Advice From Those You Trust',
            icon: get_advice_from_others_icon_url,
        },
        {
            id: scheduleTimeWithQuollSlug,
            label: 'Schedule Time With Quoll',
            icon: schedule_time_with_quoll_icon_url,
        },
        {
            id: 'how-to-navigate',
            label: 'How to Use the Projects',
            icon: how_to_navigate_icon_url,
        }
    ]

    const singleColumnSections = [getAdviceFromOthersSlug, scheduleTimeWithQuollSlug];
    // const singleColumnSections = [getAdviceFromOthersSlug, scheduleTimeWithQuollSlug, 'help-me-choose'];

    const handleProjectsViewNavHover = (id) => {
        setProjectsViewNavHoverId(id);
    }

    const handleLabToggle = () => {

        const isShowLabCurrentlyShowing = showLab;

        setShowLab(!showLab);
        if (!isShowLabCurrentlyShowing) {
            handleUrlSubsectionChange(comboLabSlug);
            handleLoggingGaEventFromProperty('projects_lab_opened');
        } else {
            handleRevertToPreviousSubsectionUrl();
        }
    }

    useEffect(() => {
        if (deviceType !== 'mobile' && selectedSection === comboLabSlug) {
            setSelectedSection(whatWeWouldDoSlug);
        } else if (deviceType === 'mobile' && selectedSection === inComboLabSlug) {
            setSelectedSection(comboLabSlug);
        } else if (deviceType === 'mobile' && showLab) {
            setShowLab(false);
        }

    }, [deviceType, selectedSection]);

    const comboSlugs = [comboLabSlug, inComboLabSlug];

    // --- Sticky Toggle Bar Logic ---
    // This state will hold the height of the nav bar above
    const [navBarHeight, setNavBarHeight] = useState(0);
    // Ref for the projects-view-toggle bar
    const toggleBarRef = useRef(null);

    useEffect(() => {
        // Only run this logic on mobile
        if (deviceType !== 'mobile') return;
        // Query the nav bar above by its class name
        const navBar = document.querySelector('.property-explorer-section-nav-bar-desktop-wrapper');
        if (!navBar) return;

        // Function to update the height
        const updateHeight = () => {
            setNavBarHeight(navBar.offsetHeight || 0);
        };

        updateHeight();
        // Observe changes in nav bar height
        const resizeObserver = new window.ResizeObserver(updateHeight);
        resizeObserver.observe(navBar);

        // Clean up observer on unmount
        return () => resizeObserver.disconnect();
    }, [deviceType]);
    // --- End Sticky Toggle Bar Logic ---

    
    // When selectedSection changes scroll to .projects-view-toggle
    useEffect(() => {
        const projectsViewToggle = document.querySelector('.content-wrapper');
        if (projectsViewToggle) {
            projectsViewToggle.scrollIntoView({ behavior: 'smooth' });
        }
    }, [selectedSection]);

    return (
        <DndContext onDragStart={handleDragStart} onDragMove={handleDragMove} onDragOver={handleDragOver} onDragEnd={handleDragEnd}>
            <div className="your-options-section-container">
                {showLab && (
                    // <ProjectsPayoffSimulator
                    //     propertyData={propertyData}
                    //     handleClickOutside={handleLabToggle}
                    // />
                    <WhatIfMachinePlanSummary
                        propertyData={propertyData}
                        selectedProjectsList={selectedProjectsList}
                        notSelectedProjectsList={notSelectedProjectsList}
                        handleUserAddingAProject={handleUserAddingSimulatorProjectId}
                        handleUserRemovingAProject={handleUserRemovingSimulatorProjectId}
                        handleSelectedProjectsListUpdate={setSelectedProjectsList}
                        handleOutsideClick={handleLabToggle}
                    />
                )}
                <div className={`view-projects__content ${deviceType} ${draggingMoving ? 'true' : 'false'} ${singleColumnSections.includes(projectsView) ? 'single-column' : ''}`}>
                    {showPopup && (
                        <>
                            {popupType === getAdviceFromOthersSlug &&
                                <SendProjectToOthers
                                    projects={refinedProjectsList}
                                    propertyData={propertyData}
                                    showTitle={true}
                                    handleOutsideClick={handleClosePopup}
                                />
                            }
                            {popupType === scheduleTimeWithQuollSlug &&
                                <ScheduleTimeWithQuoll
                                    inline={false}
                                    projects={refinedProjectsList}
                                    propertyData={propertyData}
                                    showTitle={true}
                                    handleOutsideClick={handleClosePopup}
                                />
                            }
                        </>
                    )}
                    <div className={`view-projects__content-center-column ${deviceType}`}>
                        {/* Sticky projects-view-toggle bar with dynamic top on mobile */}
                        <div
                            ref={toggleBarRef}
                            className={`projects-view-toggle ${deviceType}`}
                            style={deviceType === 'mobile' ? { position: 'sticky', top: navBarHeight, zIndex: 100 } : {}}
                        >
                            {menuItems.map((item) => {

                                const isActiveOrHovering = selectedSection === item.id || projectsViewNavHoverId === item.id;

                                const icon = CreateCloudfrontUrl(item.icon);
                                // const icon = isActiveOrHovering ? item.icon_dark : item.icon_light;


                                return (
                                    <button
                                        key={item.id}
                                        className={`projects-view-toggle__button ${selectedSection === item.id ? 'active' : 'in-active'} ${deviceType}`}
                                        onClick={() => setSelectedSection(item.id)}
                                        onMouseEnter={() => handleProjectsViewNavHover(item.id)}
                                        onMouseLeave={() => handleProjectsViewNavHover(null)}
                                    >
                                        <div className={`projects-view-toggle__button-icon-wrapper ${isActiveOrHovering ? 'active' : 'in-active'}`}>
                                            <img src={icon} alt={item.label} />
                                        </div>

                                        <span>{item.label}</span>
                                    </button>
                                )
                            })}
                            {(selectedProjectsList.length > 0 || deviceType === 'mobile') &&
                                <button
                                    className={`projects-view-toggle__button ${(comboSlugs.includes(selectedSection) || comboSlugs.includes(projectsViewNavHoverId)) ? 'active' : 'in-active'} ${deviceType}`}
                                    onClick={() => setSelectedSection(deviceType === 'mobile' ? comboLabSlug : inComboLabSlug)}
                                    onMouseEnter={() => handleProjectsViewNavHover(inComboLabSlug)}
                                    onMouseLeave={() => handleProjectsViewNavHover(null)}
                                >
                                    <div className={`projects-view-toggle__button-icon-wrapper lab`}>
                                        <FlaskConical />
                                    </div>
                                    <span>
                                        {deviceType === 'mobile' ? 'Combo Lab' : 'Added to Lab'}
                                    </span>
                                    {/* {deviceType === 'mobile' && (
                                        <div className="projects-view-toggle__button-in-lab-project-count">
                                            {selectedProjectsList.length}
                                        </div>
                                    )} */}
                                </button>
                            }

                        </div>
                        {selectedSection === whatWeWouldDoSlug && (
                            <WhatWeWouldDo
                                handleProjectClick={handleProjectClick}
                                projects={refinedProjectsList}
                                propertyAreasWithProjects={propertyAreasWithProjects}
                            />
                        )}
                        {selectedSection === browseSlug && (
                            <HouseView
                                handleProjectClick={handleProjectClick}
                                propertyAreasWithProjects={propertyAreasWithProjects}
                                projects={refinedProjectsList}
                            // handleAreaClick={handleAreaClick}
                            // selectedArea={selectedArea}
                            />
                        )}
                        {/* {projectsView === 'list' && (
                            <ListView
                                projects={refinedProjectsList}
                                climate_risks={climate_risks}
                                handleProjectClick={handleProjectClick}
                            />
                        )} */}
                        {selectedSection === helpMeChooseSlug && (
                            <HelpMeChoose
                                projects={refinedProjectsList}
                                propertyData={propertyData}
                                handleProjectClick={handleProjectClick}
                            />
                        )}
                        {selectedSection === inComboLabSlug && (
                            <ListView
                                projects={selectedProjectsList}
                                climate_risks={climate_risks}
                                handleProjectClick={handleProjectClick}
                                simulatorView={true}
                                handleUserRemovingSimulatorProjectId={handleUserRemovingSimulatorProjectId}
                            />
                        )}
                        {(selectedSection === comboLabSlug && deviceType === 'mobile') && (
                            <WhatIfMachinePlanSummary
                                propertyData={propertyData}
                                selectedProjectsList={selectedProjectsList}
                                notSelectedProjectsList={notSelectedProjectsList}
                                handleUserAddingAProject={handleUserAddingSimulatorProjectId}
                                handleUserRemovingAProject={handleUserRemovingSimulatorProjectId}
                                handleSelectedProjectsListUpdate={setSelectedProjectsList}
                                handleOutsideClick={handleLabToggle}
                                inline={true}
                            />
                        )}
                        {deviceType === 'mobile' && (
                            <div className="need-additional-help-container">
                                <span className="need-additional-help-container__title">Need Additional Help?</span>
                                {needAdditionalHelpMenuItems.map((item) => (
                                    <button
                                        key={item.id}
                                        className="need-additional-help-button-container"
                                        onClick={() => handleScheduleTimeOrGetAdviceClick(item.id)}
                                    >
                                        <div className="need-additional-help-button-icon-container">
                                            <img src={item.icon} alt={item.label} />
                                        </div>
                                        <span className="need-additional-help-button-label text-align-center">{item.label}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                        {(deviceType === 'mobile' && (draggingMoving || draggingOver)) && (
                            <DroppableContainer
                                id="simulator"
                                className={`view-projects__draggable-container simulator-container ${draggingMoving ? 'dragging-moving' : ''} ${draggingOver ? 'dragging-over' : ''} ${deviceType}`}
                            >
                                <div className="simulator-empty-state">
                                    <div className="simulator-empty-state__header">
                                        <div className="simulator-empty-state__icon-wrapper">
                                            <FlaskConical />
                                        </div>
                                        <span className="simulator-empty-state__title text-align-center">
                                            Project Combo Lab
                                        </span>
                                    </div>
                                    {(draggingOver || draggingMoving) &&
                                        <p className="simulator-empty-state__description drop-here text-align-center">
                                            Drop the project here!
                                        </p>
                                    }
                                    {/* {(!draggingOver && !draggingMoving) &&
                                        <>
                                            {selectedProjectsList.length > 0
                                                ?
                                                <>
                                                    <ProjectsSummaryData projects_list={selectedProjectsList} direction="summary" />
                                                    <div className="simulator-with-projects__view-projects-buttons-container">
                                                        <button
                                                            className="simulator-with-projects__view-projects-button box-shadow-standard"
                                                            onClick={() => handleLabToggle()}
                                                        >
                                                            See Full Cost Benefit Analysis
                                                        </button>
                                                        <button
                                                            className="simulator-with-projects__view-projects-button clear box-shadow-standard"
                                                            onClick={handleClearSimulator}
                                                        >
                                                            Clear
                                                        </button>
                                                    </div>
                                                </>
                                                : <p className="simulator-empty-state__description text-align-center">
                                                    Drag and drop projects you're interested in here to see how different combinations pay off!
                                                </p>
                                            }

                                        </>
                                    } */}
                                </div>
                            </DroppableContainer>
                        )}

                    </div>

                    {!singleColumnSections.includes(selectedSection) && deviceType !== 'mobile' &&
                        <div className="view-projects__draggable-containers-frame">
                            <ProjectsSummaryData projects_list={refinedProjectsList} propertyData={propertyData} direction="sidebar" />
                            <DroppableContainer
                                id="simulator"
                                className={`view-projects__draggable-container simulator-container ${draggingMoving ? 'dragging-moving' : ''} ${draggingOver ? 'dragging-over' : ''}`}
                            >
                                <div className="simulator-empty-state">
                                    <div className="simulator-empty-state__header">
                                        <div className="simulator-empty-state__icon-wrapper">
                                            <FlaskConical />
                                        </div>
                                        <span className="simulator-empty-state__title text-align-center">
                                            Project Combo Lab
                                        </span>
                                    </div>
                                    {(draggingOver || draggingMoving) &&
                                        <p className="simulator-empty-state__description drop-here text-align-center">
                                            Drop the project here!
                                        </p>
                                    }
                                    {(!draggingOver && !draggingMoving) &&
                                        <>
                                            {selectedProjectsList.length > 0
                                                ?
                                                <>
                                                    <ProjectsSummaryData projects_list={selectedProjectsList} direction="summary" />
                                                    <div className="simulator-with-projects__view-projects-buttons-container">
                                                        <button
                                                            className="simulator-with-projects__view-projects-button box-shadow-standard"
                                                            onClick={() => handleLabToggle()}
                                                        >
                                                            See Full Cost Benefit Analysis
                                                        </button>
                                                        <button
                                                            className="simulator-with-projects__view-projects-button clear box-shadow-standard"
                                                            onClick={handleClearSimulator}
                                                        >
                                                            Clear
                                                        </button>
                                                    </div>
                                                </>
                                                : <p className="simulator-empty-state__description text-align-center">
                                                    Drag and drop projects you're interested in here to see how different combinations pay off!
                                                </p>
                                            }

                                        </>
                                    }
                                </div>
                            </DroppableContainer>
                            <div className="need-additional-help-container">
                                <span className="need-additional-help-container__title">Need Additional Help?</span>
                                {needAdditionalHelpMenuItems.map((item) => (
                                    <button
                                        key={item.id}
                                        className="need-additional-help-button-container"
                                        onClick={() => handleScheduleTimeOrGetAdviceClick(item.id)}
                                    >
                                        <div className="need-additional-help-button-icon-container">
                                            <img src={item.icon} alt={item.label} />
                                        </div>
                                        <span className="need-additional-help-button-label text-align-center">{item.label}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    }
                </div>

            </div >
        </DndContext >
    );
};

// Create a new component for the droppable containers
const DroppableContainer = ({ id, children, className }) => {
    const { setNodeRef, isOver } = useDroppable({
        id: id
    });

    return (
        <div
            ref={setNodeRef}
            className={`${className} ${isOver ? 'droppable-over' : ''}`}
        >
            {children}
        </div>
    );
};

export default ViewProjects;